import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { SupportComponent } from './features/support/support.component';
import { AboutUsComponent } from './features/about-us/about-us.component';
import { FeesComponent } from './features/fees/fees.component';
import { TermsConditionsComponent } from './features/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './features/privacy-policy/privacy-policy.component';
import { AmlPolicyComponent } from './features/aml-policy/aml-policy.component';
import { RiskDisclosureComponent } from './features/risk-disclosure/risk-disclosure.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'user',
    loadChildren: () =>
      import('./features/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'trading',
    loadChildren: () =>
      import('./features/trading-terminal/trading-terminal.module').then(
        (m) => m.TradingTerminalModule,
      ),
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'support',
    component: SupportComponent,
  },
  {
    path: 'about',
    component: AboutUsComponent,
  },
  {
    path: 'fees',
    component: FeesComponent,
  },
  {
    path: 'terms-conditions',
    component: TermsConditionsComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'aml-policy',
    component: AmlPolicyComponent,
  },
  {
    path: 'risk-disclosure',
    component: RiskDisclosureComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
